// extracted by mini-css-extract-plugin
module.exports = {"header":"InstructorApproverHeader_header__mcOk3","breadcrumb":"InstructorApproverHeader_breadcrumb__2BK_T","back":"InstructorApproverHeader_back__22JL8"};